export default __webpack_public_path__ + "static/media/end_tb_logo.a1447876.png";